import { API_BASE_URL_ENV } from "../common/common";
import BaseService from "./BaseService";
import http from "./HttpService";

const apiEndpoint = API_BASE_URL_ENV() + "/home";

export default class HomeHeaderService extends BaseService {
	constructor() {
		super(apiEndpoint);
	}
	getList(type) {
		return http.get(`${this.apiEndpoint}/${type}`);
	}
}
